import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { apiClient } from '@/resources/upgrade/jsonapi-client';

const LOGGED_IN_ONLY_PATHS = ['/my-account'];

interface ILogoutMutationOptions {
  onSuccess?: () => void;
  onFailure?: (error: Error) => void;
}

export function useLogoutMutation(options?: ILogoutMutationOptions) {
  const queryClient = useQueryClient();
  const router = useRouter();

  const mutation = useMutation({
    mutationFn: () => apiClient.delete('sessions'),
    onSuccess: async () => {
      if (LOGGED_IN_ONLY_PATHS.some((path) => router.pathname.startsWith(path))) {
        await router.replace('/');
      }

      queryClient.resetQueries();
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      options?.onFailure?.(error);
    },
  });

  return [mutation.mutate, mutation] as const;
}
